<template>
  <div>
    <multiselect
      class="form-control"
      v-model="modelo.idcategoria"
      :options="datos"
      track-by="id"
      label="nombre"
      :searchable="false"
      :close-on-select="true"
      :show-labels="false"
      placeholder="Seleccione..."></multiselect>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    props: { model: Object, default: { type: Object, required: false, default: null } },
    data() {
      return {
        modelo: { idcategoria: null },
      };
    },
    watch: {
      'modelo.idcategoria': function () {
        this.model.idcategoria = this.modelo.idcategoria;
      },
      default: function (a) {
        if (a == null) return;
        this.modelo.idcategoria = a;
      },
    },
    computed: {
      ...mapState({
        datos: (state) => {
          if (state.UNIDAD_NEGOCIO_ID) {
            let esam = 1;
            let dbs = 10;
            if (state.UNIDAD_NEGOCIO_ID == esam) {
              let usuarioid = state.DATA_USER.id;
              const apidev = process.env.VUE_APP_GRAPHQL;
              let isdevmode = false;
              if( apidev.includes("apidev") ){ isdevmode = true; }
              let ok =
                usuarioid == -1 || usuarioid == 21373 || usuarioid == 35886 || usuarioid == 95 || usuarioid == 54803 || usuarioid == 59716;
              if (!ok && !isdevmode) {
                // 5 esam cursos, 19 cursos wobi
                return state.categoria.items.filter(
                  (item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID && (item.id == 5 || item.id == 19 || item.id == 56),
                );
              }
            } else if (state.UNIDAD_NEGOCIO_ID == dbs) {
              // window.console.log('state.categoria.items',state.categoria.items);
              
              return state.categoria.items.filter(
                (item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID && (item.id == 28 || item.id == 57),
              );
            }
            return state.categoria.items.filter((item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID);
          }
          return [];
        },
      }),
    },
    mounted() {
      let unidad = this.$store.state.CARGO.sede.unidad_negocio;
      let esam = 1;
      if (unidad == esam) {
        let usuarioid = this.$store.state.DATA_USER.id;
        let ok = usuarioid == -43 || usuarioid == 21373 || usuarioid == 35886 || usuarioid == 95 || usuarioid == 54803 || usuarioid == 59716;
        const apidev = process.env.VUE_APP_GRAPHQL;
        let isdevmode = false;
        if( apidev.includes("apidev") ){ isdevmode = true; }

        if (!ok && !isdevmode) {
          this.$root.$notify.show(`Esta autorizado solo a crear cursos, personal de la DNA puede crear posgrados`, {
            color: 'green',
            x: 'right',
          });
        }
      }
    },
  };
</script>
